import React, { useEffect, useState } from 'react';
import { timeLeft } from '../../utils/format';

// Renders a live countdown to a unix timestamp (seconds).
export default function CountdownTimer({ targetTs, onDone, className = '' }) {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    const id = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = targetTs ? Math.max(0, targetTs - now) : 0;

  useEffect(() => {
    if (targetTs && remaining === 0 && onDone) onDone();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remaining, targetTs]);

  return <span className={className}>{timeLeft(remaining)}</span>;
}
